<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="DEDICATION1">Come you indoors, come home; your fading fire<br/>Mend first and vital candle in close heart’s vault.</p>
<p class="DEDICATION2">Gerard Manley Hopkins, S.J.<br/>“The Candle Indoors”</p>
<p class="DEDICATION3">To the members of the<br/>Academy of Catholic Theology</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Oakes_A_Theology_of_Grace3.vue?1a8a40d4